module.exports = "/images/vendor/flag-icon-css/flags/4x3/ls.svg?c0799ebf1d583d0d38408484bb56ec44";